import React from "react";

interface YesNoRadioFieldProps {
    name: string;
    value: boolean | null | undefined;
    onChange: (value: boolean) => void;
    error?: string;
    yesId?: string;
    noId?: string;
    disabled?: boolean;
}

/**
 * Reusable Yes/No radio button field component
 */
const YesNoRadioField = ({ name, value, onChange, error, yesId, noId, disabled = false }: YesNoRadioFieldProps) => {
    return (
        <>
            <div className={`${error ? "text-error" : ""} ${disabled ? "opacity-50" : ""}`}>
                <label className={`flex items-center gap-2 h-9 py-2 px-1 ${disabled ? "" : "cursor-pointer"}`}>
                    <input
                        type="radio"
                        name={name}
                        value="Yes"
                        checked={value === true}
                        onChange={() => onChange(true)}
                        className={`radio ${error ? "radio-error" : "radio-primary"}`}
                        id={yesId}
                        disabled={disabled}
                    />
                    <span className="text-base-content">Yes</span>
                </label>

                <label className={`flex items-center gap-2 h-9 py-2 px-1 ${disabled ? "" : "cursor-pointer"}`}>
                    <input
                        type="radio"
                        name={name}
                        value="No"
                        checked={value === false}
                        onChange={() => onChange(false)}
                        className={`radio ${error ? "radio-error" : "radio-primary"}`}
                        id={noId}
                        disabled={disabled}
                    />
                    <span className="text-base-content">No</span>
                </label>
            </div>
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </>
    );
};

export default YesNoRadioField;
